export default __webpack_public_path__ + "static/media/orange_medium.6834501b.png";